import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'

function SelectedOptionIcon() {
    return <FontAwesomeIcon icon={faCheck} />
}

export default SelectedOptionIcon
